import { createModuleApi } from '@wit-support/admin-client-core';
const api = createModuleApi({ errorFormat: 'raw' });
export function setInsightsApiBaseUrl(url) {
    api.setBaseUrl(url);
}
function qs(from, to, extra) {
    const p = new URLSearchParams();
    if (from)
        p.set('from', from);
    if (to)
        p.set('to', to);
    for (const [k, v] of Object.entries(extra ?? {}))
        p.set(k, v);
    const s = p.toString();
    return s ? `?${s}` : '';
}
export async function getUsageSummary(from, to) {
    return api.get(`/api/llm-usage/summary${qs(from, to)}`);
}
/** Default page size for the recent-calls list. */
export const RECENT_CALLS_PAGE_SIZE = 50;
export async function getRecentCalls(from, to, limit = RECENT_CALLS_PAGE_SIZE, cursor) {
    const extra = { limit: String(limit) };
    if (cursor)
        extra.cursor = cursor;
    return api.get(`/api/llm-usage/recent${qs(from, to, extra)}`);
}
// `/api/llm-settings` СОЗНАТЕЛЬНО не вызывается отсюда: пять флагов, что жили
// карточкой на этом экране, переехали в единый раздел «Настройки»
// (`@wit-support/admin-module-settings`) — вторая копия вызова означала бы два
// места, где одну и ту же настройку правят, и два места, которые надо чинить.
//# sourceMappingURL=api.js.map